/**
 * @desc getCabinList
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<string>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getCabinList`, {
      method: "POST",

      ...options,
    }),
  );
}
